import {handleActions} from 'redux-actions';
import actions from './editingProfile.actions';

const reducer = handleActions(
	{
		[actions.editingProfileInit]: (state, {payload}) => ({
			...payload
		}),
		[actions.editingProfileUpdate]: (state, {payload}) => ({
			...state,
			...payload,
			user: payload.user
				? {
						...(state.user || {}),
						...payload.user
				  }
				: state.user,
			profile: payload.profile
				? {
						...(state.profile || {}),
						...payload.profile
				  }
				: state.profile
		}),
		[actions.editingProfileDone]: (state, {payload}) => null
	},
	null
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/editingProfile.reducer.js